import React, { useEffect, useState } from 'react';
import './style.css';
import moment from 'moment/moment';
import { getDeliveryRate } from '../../services/metrics';

const DeliveryRate = () => {
  const [deliveryMetrics, setDeliveryMetrics] = useState({
    sent: 0,
    delivered: 0,
  });

  useEffect(() => {
    const startDate = moment()
      .subtract(1, 'days')
      .startOf('day');
    const endDate = moment()
      .subtract(1, 'days')
      .endOf('day');
    getDeliveryRate(startDate, endDate).then(res => {
      setDeliveryMetrics(res);
    });
  }, []);
  let text = 'No Delivery data';
  let className = '';
  let percentage = 0;
  if (deliveryMetrics.sent && deliveryMetrics.delivered) {
    percentage = (deliveryMetrics.delivered / deliveryMetrics.sent) * 1000;
    percentage = Math.round(percentage);
    percentage /= 10;
    if (percentage >= 95) {
      className = 'delivery-rate-good';
    } else if (percentage >= 90) {
      className = 'delivery-rate-warning';
    } else {
      className = 'delivery-rate-danger';
    }
    text = `${percentage} %`;
  }
  return (
    <div>
      <center>
        <h4 className={className}>Yesterday&apos;s delivery rate</h4>
        <h3 className={className}> {text} </h3>
      </center>
    </div>
  );
};

export default DeliveryRate;
